import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { STORAGE_CONSTANTS } from 'Constants'
import { IAuthenticatedUser } from 'Models/ResponseModels'
import { storageService } from 'Services/storage.service'

interface IState {
  authenticatedUser: IAuthenticatedUser
  isLoggedIn: boolean
  alreadyTrigger: boolean
  uniqueSessionId: string
  clientIp?: string
}

const initialState: IState = {
  authenticatedUser: {},
  isLoggedIn: false,
  alreadyTrigger: false,
  uniqueSessionId: '',
}

const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    updateUserDetails: (
      state,
      action: PayloadAction<{ user: IAuthenticatedUser; uniqueSessionId: string }>,
    ) => {
      state.authenticatedUser = action.payload.user
      state.isLoggedIn = true
      state.uniqueSessionId = action.payload.uniqueSessionId
      // storageService.setValueInLocalStorage(STORAGE_CONSTANTS.AUTHENTICATED_USER, action.payload)
    },
    updateClientIp: (state, action: PayloadAction<string>) => {
      state.clientIp = action.payload
    },
    updateTriggered: (state, action: PayloadAction<any>) => {
      state.alreadyTrigger = true
    },
    resetUser: (state) => {
      console.log(state)
      // storageService.removeValueFromLocalStorage(STORAGE_CONSTANTS.AUTHENTICATED_USER)
      state.authenticatedUser = {}
      state.isLoggedIn = false
      state.alreadyTrigger = false
    },
  },
})

const { reducer } = userSlice
const { updateUserDetails, updateClientIp, resetUser, updateTriggered } = userSlice.actions

export { reducer as userReducer, updateUserDetails, updateClientIp, resetUser, updateTriggered }
